import React from 'react';
import type { FormFieldProps } from 'semantic-ui-react';

import { FormField } from '../FormField/FormField';

import type { RawDateInputProps, RawDateInputValueType } from './RawDateInput';
import { RawDateInput } from './RawDateInput';

export type DateInputProps = {
  description?: string;
  disabled?: RawDateInputProps['disabled'];
  excludeDates?: RawDateInputProps['excludeDates'];
  id?: RawDateInputProps['id'];
  label?: React.ReactNode;
  minDate?: RawDateInputProps['minDate'];
  name: RawDateInputProps['name'];
  onBlur?: RawDateInputProps['onBlur'];
  onChange?: RawDateInputProps['onChange'];
  onFocus?: RawDateInputProps['onFocus'];
  placeholder?: RawDateInputProps['placeholder'];
  removeTodayButton?: RawDateInputProps['removeTodayButton'];
  Tooltip?: React.ReactNode;
  direction?: RawDateInputProps['direction'];
};

const noopFunction = () => {};

export const DateInput = ({
  description,
  disabled,
  excludeDates,
  id,
  label,
  minDate,
  name,
  onBlur = noopFunction,
  onChange = noopFunction,
  onFocus = noopFunction,
  placeholder,
  removeTodayButton,
  Tooltip,
  direction,
}: DateInputProps) => {
  id = id || name;
  return (
    <FormField
      {...{
        description,
        disabled,
        id,
        name,
        label,
        onClear: async (v: RawDateInputValueType) => onChange(v),
        Tooltip,
      }}
      renderField={({
        value,
        onBlur: formOnBlur,
        setFieldValue,
        invalid,
        schemaProperty,
      }: {
        value: RawDateInputValueType;
      } & FormFieldProps) => {
        return (
          <RawDateInput
            disabled={disabled}
            direction={direction}
            excludeDates={excludeDates}
            id={id}
            invalid={invalid}
            minDate={minDate}
            name={name}
            onBlur={date => {
              onBlur(date);
              formOnBlur({ target: { name, value: date } });
            }}
            onChange={date => {
              void onChange(date);
              setFieldValue(name, date);
            }}
            onFocus={() => {
              onFocus();
            }}
            placeholder={placeholder}
            removeTodayButton={removeTodayButton}
            type={schemaProperty.type}
            value={value}
          />
        );
      }}
    />
  );
};
